import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["icon",  ($props.size == 'small') ? $props.color+' w-5 h-5' : $props.color+' w-12 h-12']),
    style: _normalizeStyle('-webkit-mask-image:url(' + $props.iconImg + ');mask-image:url(' + $props.iconImg + ');mask-position:center;-webkit-mask-position:center;mask-size:cover;-webkit-mask-size:cover;')
  }, null, 6))
}